<div id="roles-sidebar" class="side-nav fixed z-depth-2 style-5" *ngIf="currentUser">
    <ul [ngSwitch]="currentUser.role">
        <ng-container *ngSwitchCase="'ATOM_Administrator'">
            <!-- Users & Roles -->
            <ng-container *ngIf="hasSection('USER_ROLE_SECTION');then usersAndRoles"></ng-container>
            <!-- Infrastructure -->
            <ng-container *ngIf="hasSection('INFRASTRUCTURE_SECTION'); then infrastructure"></ng-container>
            <!-- Tools section -->
            <ng-container *ngIf="hasSection('TOOL_SECTION');then tools"></ng-container>
            <!-- Issues -->
            <ng-container *ngIf="hasSection('ISSUES_SECTION');then issues"></ng-container>
            <!-- Tickets -->
            <ng-container *ngIf="hasSection('TICKETS_SECTION'); then tickets"></ng-container>
            <!-- Audits -->
            <ng-container *ngIf="hasSection('AUDIT_SECTION'); then audits"></ng-container>
            <!-- Settings -->
            <ng-container *ngIf="hasSection('SETTINGS_SECTION'); then settings"></ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_Manufacturing_Technician'">
            <!-- Create tool requests -->
            <ng-container *ngIf="hasSection('REQUEST_TOOLS_SECTION')">
                <ng-container *ngTemplateOutlet="requestTools"></ng-container>
            </ng-container>
            <!-- Create tool returns -->
            <ng-container *ngIf="hasSection('RETURN_TOOLS_SECTION')">
                <ng-container *ngTemplateOutlet="returnTools"></ng-container>
            </ng-container>
            <!-- Issues -->
            <ng-container *ngIf="hasSection('ISSUES_SECTION')">
                <ng-container *ngTemplateOutlet="issues"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_Operator'">
            <!-- Process Tool requests -->
            <ng-container *ngIf="hasSection('APPROVE_TOOL_REQUESTS_SECTION')">
                <ng-container *ngTemplateOutlet="approveToolRequests"></ng-container>
            </ng-container>
            <!-- Process Tool returns -->
            <ng-container *ngIf="hasSection('APPROVE_TOOL_RETURNS_SECTION')">
                <ng-container *ngTemplateOutlet="approveToolReturns"></ng-container>
            </ng-container>
            <!-- Tools -->
            <ng-container *ngIf="hasSection('TOOL_SECTION')">
                <ng-container *ngTemplateOutlet="tools"></ng-container>
            </ng-container>
            <!-- Tickets -->
            <ng-container *ngIf="hasSection('TICKETS_SECTION')">
                <ng-container *ngTemplateOutlet="tickets"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_Storage'">
            <!-- Process tool requests -->
            <ng-container *ngIf="hasSection('PROCESS_TOOL_REQUESTS_SECTION')">
                <ng-container *ngTemplateOutlet="processToolRequests"></ng-container>
            </ng-container>
            <!-- Process tool requests -->
            <ng-container *ngIf="hasSection('PROCESS_TOOL_RETURNS_SECTION')">
                <ng-container *ngTemplateOutlet="processToolReturns"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_Service'">
            <!-- Process all -->
            <ng-container *ngIf="hasSection('PROCESS_TICKETS_SECTION')">
                <ng-container *ngTemplateOutlet="processServiceRequests"></ng-container>
            </ng-container>
            <!-- Process categories -->
            <ng-container *ngIf="hasSection('PROCESS_TICKETS_SECTION')">
                <ng-container *ngTemplateOutlet="processServiceRequestsByCategories"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_STRAIN_Administrator'">
            <!-- Users & Roles -->
            <ng-container *ngIf="hasSection('USER_ROLE_SECTION') && hasToolbarItem('tool');then usersAndRoles"></ng-container>
            <!-- Infrastructure -->
            <ng-container *ngIf="hasSection('INFRASTRUCTURE_SECTION') && hasToolbarItem('tool'); then infrastructure"></ng-container>
            <!-- Tools section -->
            <ng-container *ngIf="hasSection('TOOL_SECTION') && hasToolbarItem('tool');then tools"></ng-container>
            <!-- Strain section -->
            <ng-container *ngIf="hasSection('STRAIN_SECTION') && hasToolbarItem('strain');then strain"></ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'ATOM_STRAIN_Technician'">
            <ng-container *ngIf="hasSection('STRAIN_SECTION') && hasToolbarItem('strain');then strain"></ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <!-- Users & Roles -->
            <ng-container *ngIf="hasSection('USER_ROLE_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="usersAndRoles"></ng-container>
            </ng-container>
            <!-- Infrastructure -->
            <ng-container *ngIf="hasSection('INFRASTRUCTURE_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="infrastructure"></ng-container>
            </ng-container>
            <!-- Tools section -->
            <ng-container *ngIf="hasSection('TOOL_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="tools"></ng-container>
            </ng-container>
            <!-- Issues -->
            <ng-container *ngIf="hasSection('ISSUES_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="issues"></ng-container>
            </ng-container>
            <!-- Tickets -->
            <ng-container *ngIf="hasSection('TICKETS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="tickets"></ng-container>
            </ng-container>


            <!-- Create tool requests -->
            <ng-container *ngIf="hasSection('REQUEST_TOOLS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="requestTools"></ng-container>
            </ng-container>
            <!-- Create tool returns -->
            <ng-container *ngIf="hasSection('RETURN_TOOLS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="returnTools"></ng-container>
            </ng-container>

            <!-- Process Tool requests -->
            <ng-container *ngIf="hasSection('APPROVE_TOOL_REQUESTS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="approveToolRequests"></ng-container>
            </ng-container>
            <!-- Process Tool returns -->
            <ng-container *ngIf="hasSection('APPROVE_TOOL_RETURNS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="approveToolReturns"></ng-container>
            </ng-container>


            <!-- Process tool requests -->
            <ng-container *ngIf="hasSection('PROCESS_TOOL_REQUESTS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="processToolRequests"></ng-container>
            </ng-container>
            <!-- Process tool requests -->
            <ng-container *ngIf="hasSection('PROCESS_TOOL_RETURNS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="processToolReturns"></ng-container>
            </ng-container>

            <!-- Process all -->
            <ng-container *ngIf="hasSection('PROCESS_TICKETS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="processServiceRequests"></ng-container>
            </ng-container>

            <!-- Process categories -->
            <ng-container *ngIf="hasSection('PROCESS_TICKETS_SECTION') && hasToolbarItem('tool')">
                <ng-container *ngTemplateOutlet="processServiceRequestsByCategories"></ng-container>
            </ng-container>

            <!-- Audits -->
            <ng-container *ngIf="hasSection('AUDIT_SECTION') && hasToolbarItem('tool'); then audits"></ng-container>

            <!-- Strain Section -->
            <ng-container *ngIf="hasSection('STRAIN_SECTION') && hasToolbarItem('strain'); then strain"></ng-container>
        </ng-container>
    </ul>
</div>

<ng-template #usersAndRoles>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">assignment_ind</i>
            <span>{{ 'nav.sections.usersAndRoles.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/role-management"
           *ngIf="hasPermission('VIEW_ROLES')"
           class="list-item">
            <i class="material-icons">security</i>
            <span>{{ 'nav.sections.usersAndRoles.items.roles' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active"
        *ngIf="hasPermission('VIEW_USERS')">
        <a routerLink="/user-management"
           class="list-item">
            <i class="material-icons">group</i>
            <span>{{ 'nav.sections.usersAndRoles.items.users' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #infrastructure>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">settings_input_composite</i>
            <span>{{ 'nav.sections.infrastructure.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/plant-management"
           *ngIf="hasPermission('VIEW_PLANTS')"
           class="list-item">
            <i class="material-icons">domain</i>
            <span>{{ 'nav.sections.infrastructure.items.plants' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/value-stream-management"
           *ngIf="hasPermission('VIEW_VALUE_STREAMS')"
           class="list-item">
            <i class="material-icons">device_hub</i>
            <span>{{ 'nav.sections.infrastructure.items.valueStreams' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/line-management"
           *ngIf="hasPermission('VIEW_LINES')"
           class="list-item">
            <i class="material-icons">view_headline</i>
            <span>{{ 'nav.sections.infrastructure.items.lines' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active">
        <a routerLink="/equipment-management"
           *ngIf="hasPermission('VIEW_EQUIPMENT')"
           class="list-item">
            <i class="material-icons">business_center</i>
            <span>{{ 'nav.sections.infrastructure.items.equipment' | translate }}</span>
        </a>
    </li>

    <!-- Manage Process Types -->
    <li routerLinkActive="active">
        <a routerLink="/process-types-management"
           *ngIf="hasPermission('VIEW_PROCESS_TYPES')"
           class="list-item">
            <i class="material-icons">receipt</i>
            <span>{{ 'admin.equipment.buttons.manageProcessTypes' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active">
        <a routerLink="/partnumber-management"
           *ngIf="hasPermission('VIEW_PARTNUMBERS')"
           class="list-item">
            <i class="material-icons">memory</i>
            <span>{{ 'nav.sections.infrastructure.items.partNumber' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active">
        <a routerLink="/insertion-cycles"
           *ngIf="hasPermission('VIEW_INSERTION_CYCLES')"
           class="list-item">
            <i class="material-icons">autorenew</i>
            <span>{{ 'nav.sections.infrastructure.items.insertionCycles' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active">
        <a routerLink="/lifts"

           *ngIf="hasPermission('VIEW_LIFTS')"
           class="list-item">
            <i class="material-icons">swap_vert</i>
            <span>{{ 'admin.lifts.title' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #strain>
    <li>
        <div class="side-nav-category list-item">
            <span>{{ 'nav.sections.strain.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/config"
           *ngIf="hasPermission('VIEW_STRAIN_CONFIGS')"
           class="list-item">
            <i class="material-icons">settings</i>
            <span>{{ 'nav.sections.strain.items.config' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/strain-requests"
           *ngIf="hasPermission('VIEW_STRAIN_REQUESTS')"
           class="list-item">
            <i class="material-icons">library_add</i>
            <span>{{ 'nav.sections.strain.items.newStrainRequest' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/material-requests"
           *ngIf="hasPermission('VIEW_STRAIN_MATERIAL_REQUESTS')"
           class="list-item">
            <i class="material-icons">add_shopping_cart</i>
            <span>{{ 'nav.sections.strain.items.materialRequests' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/sample-boards"
           *ngIf="hasPermission('VIEW_STRAIN_MATERIALS')"
           class="list-item">
            <i class="material-icons">developer_board</i>
            <span>{{ 'nav.sections.strain.items.sampleBoards' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/materials"
           *ngIf="hasPermission('VIEW_STRAIN_MATERIALS')"
           class="list-item">
            <i class="material-icons">gradient</i>
            <span>{{ 'nav.sections.strain.items.materials' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/planning"
           *ngIf="hasPermission('PLAN_STRAIN_REGISTRY_ITEMS')"
           class="list-item">
            <i class="material-icons">event_note</i>
            <span>{{ 'nav.sections.strain.items.planning' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/registry"
           *ngIf="hasPermission('VIEW_STRAIN_REGISTRY')"
           class="list-item">
            <i class="material-icons">folder</i>
            <span>{{ 'nav.sections.strain.items.registry' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/tickets"
           *ngIf="hasPermission('VIEW_STRAIN_TICKETS')"
           class="list-item">
            <i class="material-icons">bug_report</i>
            <span>{{ 'nav.sections.strain.items.ticket' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/strain/escalation"
           *ngIf="hasPermission('VIEW_STRAIN_ESCALATIONS') || hasPermission('MANAGE_STRAIN_ESCALATIONS')"
           class="list-item">
            <i class="material-icons">add_alert</i>
            <span>{{ 'nav.sections.strain.items.escalation' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #tools>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">details</i>
            <span>{{ 'nav.sections.tools.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/tool-management"
           *ngIf="hasPermission('VIEW_TOOLS')"
           class="list-item">
            <i class="material-icons">build</i>
            <span>{{ 'nav.sections.tools.items.tools' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/tool-maintenance-plans"
           *ngIf="hasPermission('VIEW_MAINTENANCE_PLANS')"
           class="list-item">
            <i class="fa fa-sun-o first"></i>
            <span>{{ 'nav.sections.tools.items.tool-maintenance' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/tool-usage"
           *ngIf="hasPermission('VIEW_TOOL_HISTORY')"
           class="list-item">
            <i class="material-icons">brightness_high</i>
            <span>{{ 'nav.sections.tools.items.toolsUsage' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/tool-history"
           *ngIf="hasPermission('VIEW_TOOL_HISTORY')"
           class="list-item">
            <i class="material-icons">history</i>
            <span>{{ 'nav.sections.tools.items.tool-history' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #issues>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">report_problem</i>
            <span>{{ 'nav.sections.issues.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('CREATE_ISSUES')">
        <a routerLink="/signal-issue"
           class="list-item">
            <i class="material-icons">report_problem</i>
            <span>{{ 'nav.sections.issues.items.signalAnIssue' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/issues"
           *ngIf="hasPermission('VIEW_ISSUES')"
           class="list-item">
            <i class="material-icons">error</i>
            <span>{{ 'nav.sections.issues.items.viewIssues' | translate }}</span>
        </a>
    </li>

    <li routerLinkActive="active">
        <a routerLink="/reasons"
           *ngIf="hasPermission('VIEW_REASONS')"
           class="list-item">
            <i class="material-icons">insert_comment</i>
            <span>{{ 'admin.issues.buttons.manageReasons' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #tickets>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">report_problem</i>
            <span>{{ 'nav.sections.tickets.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/ticket-management"
           *ngIf="hasPermission('VIEW_TICKETS')"
           class="list-item">
            <i class="material-icons">assistant_photo</i>
            <ng-container
                *ngIf="hasPermission('MANAGE_TICKETS'); then manageTickets; else viewTickets">
            </ng-container>
            <ng-template #manageTickets>
                <span
                    *ngIf="hasPermission('VIEW_TICKETS')">{{ 'nav.sections.tickets.items.manageTickets' | translate }}</span>
                <span
                    *ngIf="visitedUrls.get('/manage-tickets-create') && createdTickets > 0"
                    class="requests-counter">
                    {{ createdTickets }}
                </span>
                <span
                    *ngIf="visitedUrls.get('/manage-tickets-update') && updatedTickets > 0"
                    class="requests-counter update">
                    {{ updatedTickets }}
                </span>
            </ng-template>
            <ng-template #viewTickets>
                <span
                    *ngIf="hasPermission('VIEW_TICKETS')">{{ 'nav.sections.tickets.items.viewTickets' | translate }}</span>
            </ng-template>
        </a>
    </li>
</ng-template>

<ng-template #requestTools>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">get_app</i>
            <span>{{ 'nav.sections.tool-requests.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('CREATE_TOOL_REQUESTS')">
        <a routerLink="/tool-request"
           class="list-item">
            <i class="fa fa-cog" aria-hidden="true"></i>
            <span>{{ 'nav.sections.tool-requests.items.requestTools' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('VIEW_TOOL_REQUESTS')">
        <a routerLink="/pending-tool-requests"
           class="list-item">
            <ng-container
                *ngIf="visitedUrls.get('/pending-tool-requests');else pendingToolRequestsIcon">
                <ng-container *ngTemplateOutlet="newIcon"></ng-container>
            </ng-container>
            <ng-template #pendingToolRequestsIcon>
                <i class="fa fa-indent" aria-hidden="true"></i>
            </ng-template>
            <span>{{ 'nav.sections.tool-requests.items.pendingToolRequests' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #returnTools>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">compare_arrows</i>
            <span>{{ 'nav.sections.tool-returns.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('CREATE_TOOL_RETURNS')">
        <a routerLink="/tool-return"
           class="list-item">
            <i class="fa fa-reply" aria-hidden="true"></i>
            <span>{{ 'nav.sections.tool-returns.items.returnTools' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('CREATE_TOOL_RETURNS')">
        <a routerLink="/tool-maintenance"
           class="list-item">
            <i class="fa fa-wrench" aria-hidden="true"></i>
            <span>{{ 'nav.sections.tool-returns.items.returnForMaintenance' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('VIEW_TOOL_RETURNS')">
        <a routerLink="/pending-tool-returns"
           class="list-item">
            <i class="fa fa-outdent" aria-hidden="true"></i>
            <span>{{ 'nav.sections.tool-returns.items.pendingToolReturns' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #approveToolRequests>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">compare_arrows</i>
            <span>{{ 'nav.sections.approve-tool-requests.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('APPROVE_TOOL_REQUESTS')">
        <a routerLink="/tool-requests-lines"
           class="list-item" (click)="removeOfflineNotifications($event)">
            <span
                *ngIf="missedNotifications?.toolRequests?.approveLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.approveLineRequests }}
            </span>

            <span
                *ngIf="visitedUrls.get('/tool-requests-lines') && !missedNotifications?.toolRequests?.approveLineRequests
                 && incomingLineToolRequests > 0"
                class="requests-counter">
                    {{ incomingLineToolRequests }}
            </span>

            <i class="material-icons">view_week</i>
            <span>{{ 'nav.sections.approve-tool-requests.items.approveLineRequests' | translate }}</span>

        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('APPROVE_TOOL_REQUESTS')">
        <a routerLink="/tool-requests-facilities" (click)="removeOfflineNotifications($event)"
           class="list-item">
            <span
                *ngIf="missedNotifications?.toolRequests?.approveFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.approveFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/tool-requests-facilities')"
                class="requests-counter">
                    {{ incomingFacilityToolRequests }}
            </span>
            <i class="fa fa-square"></i>
            <span>{{ 'nav.sections.approve-tool-requests.items.approveFacilityRequests' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #approveToolReturns>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">compare_arrows</i>
            <span>{{ 'nav.sections.approve-tool-returns.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('APPROVE_TOOL_RETURNS')">
        <a routerLink="/tool-returns-lines" (click)="removeOfflineNotifications($event)"
           class="list-item">
            <span
                *ngIf="missedNotifications?.toolReturns?.approveLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.approveLineRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/tool-returns-lines')
                && !missedNotifications?.toolReturns?.approveLineRequests && incomingLineToolReturns > 0"
                class="requests-counter">
                    {{ incomingLineToolReturns }}
            </span>
            <i class="fa fa-share"></i>
            <span>{{ 'nav.sections.approve-tool-returns.items.approveLineRequests' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('APPROVE_TOOL_RETURNS')">
        <a routerLink="/tool-returns-facilities" (click)="removeOfflineNotifications($event)"
           class="list-item">
            <span
                *ngIf="missedNotifications?.toolReturns?.approveFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.approveFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/tool-returns-facilities')"
                class="requests-counter">
                    {{ incomingFacilityToolReturns }}
            </span>
            <i class="fa fa-share-square"></i>
            <span>{{ 'nav.sections.approve-tool-returns.items.approveFacilityRequests' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #processToolRequests>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">build</i>
            <span>{{ 'nav.sections.process-tool-requests.title' | translate }}</span>
        </div>
    </li>
    <!-- Here -->
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_REQUESTS')">
        <a routerLink="/incoming-tool-requests/lines" class="list-item"
           (click)="removeOfflineNotifications($event)">
            <span
                *ngIf="missedNotifications?.toolRequests?.processLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.processLineRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tool-requests/lines')
                && !missedNotifications?.toolRequests?.processLineRequests && processLineToolRequests > 0"
                class="requests-counter">
                    {{ processLineToolRequests }}
            </span>
            <i class="fa fa-download"></i>
            <span>{{ 'nav.sections.process-tool-requests.items.processLines' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_REQUESTS')">
        <a routerLink="/incoming-tool-requests/facilities" class="list-item"
           (click)="removeOfflineNotifications($event)">
            <span
                *ngIf="missedNotifications?.toolRequests?.processFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.processFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tool-requests/facilities')"
                class="requests-counter">
                    {{ processFacilityToolRequests }}
            </span>
            <i class="fa fa-cloud-download"></i>
            <span>{{ 'nav.sections.process-tool-requests.items.processFacilities' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #processToolReturns>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">build</i>
            <span>{{ 'nav.sections.process-tool-returns.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_RETURNS')">
        <a routerLink="/incoming-tools-returned/lines" class="list-item"
           (click)="removeOfflineNotifications($event)">
            <span
                *ngIf="missedNotifications?.toolReturns?.processLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.processLineRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tools-returned/lines')
                && !missedNotifications?.toolReturns?.processLineRequests && processLineToolReturns > 0"
                class="requests-counter">
                    {{ processLineToolReturns }}
            </span>
            <i class="fa fa-upload"></i>
            <span>{{ 'nav.sections.process-tool-returns.items.processLines' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_RETURNS')">
        <a routerLink="/incoming-tools-returned/facilities" class="list-item"
           (click)="removeOfflineNotifications($event)">
            <span
                *ngIf="missedNotifications?.toolReturns?.processFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.processFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tools-returned/facilities')"
                class="requests-counter">
                    {{ processFacilityToolReturns }}
            </span>
            <i class="fa fa-cloud-upload"></i>
            <span>{{ 'nav.sections.process-tool-returns.items.processFacilities' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #processServiceRequests>
    <li>
        <div class="side-nav-category list-item">
            <span>{{ 'nav.sections.process-ticket-all.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TICKETS')">
        <a routerLink="/service-tickets"
           [queryParams]="{type: 'all'}"
           class="list-item" (click)="resetNewState('/service-tickets')">
            <ng-container *ngIf="getService()">
                <ng-container *ngTemplateOutlet="newIcon"></ng-container>
            </ng-container>
            <i class="material-icons">business_center</i>
            <span>{{ 'nav.sections.process-ticket-all.items.processAll' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #processServiceRequestsByCategories>
    <li>
        <div class="side-nav-category list-item">
            <span>{{ 'nav.sections.process-ticket-categories.title' | translate }}</span>
        </div>
    </li>
    <li *ngFor="let operation of serviceOperations"
        routerLinkActive="active">
        <a routerLink="/service-tickets"
           [queryParams]="{type: 'category', facilityId: operation.id}"
           class="list-item"
           (click)="resetNewState('/service-tickets')">
            <span>{{ operation.name }}</span>
        </a>
    </li>
</ng-template>

<ng-template #audits>
    <li>
        <div class="side-nav-category list-item">
            <span>{{ 'nav.sections.audits.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/audit-management"
           class="list-item">
            <i class="material-icons">assignment</i>
            <span>{{ 'nav.sections.audits.items.manageAudits' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/request-history"
           class="list-item">
            <i class="material-icons">assignment</i>
            <span>{{ 'nav.sections.audits.items.requestHistory' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #settings>
    <li>
        <div class="side-nav-category list-item">
            <span>{{ 'nav.sections.settings.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active">
        <a routerLink="/settings"
           class="list-item">
            <i class="material-icons">settings</i>
            <span>{{ 'nav.sections.settings.items.settings' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #newIcon>
    <i class="material-icons notification">fiber_new</i>
</ng-template>
